module.exports = __webpack_public_path__ + "img/writersblockthumb.bd74d728.jpg";